export default "__VITE_ASSET__imgzkyd9__"